import * as Actions from '../actions';

const initialState = {
    courseBuilder: {
        active: false,
        lessonCycleActive: false,
        course_id: 0,
        lesson_id: 0,
        assignment_id: 0,
        quiz_id: 0,
        CourseName: '',
        LessonName: '',
        startingPoint: null,
        submittedLessons: [],
        completedLessons: [],
        lessonListIndex: 0,
        lessonCycleRedirect: false,
        lessonListWeek: 1,
        courseUnscheduled: 0
    },
    companyAuth: {
        active: false,
        company_id: 0
    },
    authPreloadRole: {
        active: false,
        role: '',
    }
}

const paramHistoryReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.UPDATE_COURSE_BUILDER_PARAMS):
        {   
            return {
                ...state,
                courseBuilder: { ...state.courseBuilder, ...action.payload }
            }
        }
        case (Actions.UPDATE_COMPANY_AUTH_PARAMS):
        {
            return {
                ...state,
                companyAuth: { ...state.companyAuth, ...action.payload }
            }
        }
        case (Actions.UPDATE_AUTH_PRELOAD_ROLE):
        {
            return {
                ...state,
                authPreloadRole: { ...state.authPreloadRole, ...action.payload }
            }
        }
        case (Actions.CLEAR_PARAMS):
        {
            return {
                ...initialState,
            }
        }
        default:
        {
            return state
        }
    }
}

export default paramHistoryReducer;


// WEBPACK FOOTER //
// src/main/components/paramHistory/store/reducers/paramHistory.reducer.js